import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";
import RecommendationHeader from "./recommendation_header";
import RecommendationDetails from "./recommendation_details";
import BookDescription from "../../book_description";
import PreviewBook from "../../preview_book/preview_book";

export default GrComponentFactory.createClass({
  displayName: "RecommendationNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
    }).isRequired,
  },

  renderRecommendationDetails() {
    return <RecommendationDetails message={this.props.resource.message}/>;
  },

  renderBookBody() {
    return (
      <div>
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.resource.book.description} />
      </div>
    );
  },

  render() {
    const resource = this.props.resource;
    const header = <RecommendationHeader recommendedToYou={resource.recommendedToYou}
                                       toUser={resource.toUser}/>;

    if (this.props.resource.message) {
      const recommendationDetails = <RecommendationDetails message={this.props.resource.message}/>;
      return (
        <SocialBookUpdate
          header={header}
          book={this.props.resource.book}
          bookBody={this.renderBookBody()}
          updateDetails={recommendationDetails}
          showBookBorder={true}
          additionalFooterLinks={[<PreviewBook book={this.props.resource.book}/>]}
          {...this.props}
          />
      );
    } else {
      return (
        <SocialBookUpdate
          header={header}
          book={this.props.resource.book}
          additionalFooterLinks={[<PreviewBook book={this.props.resource.book}/>]}
          bookBody={null}
          updateDetails={null}
          {...this.props}
          />
      );
    }
  },
});
